const isDevelopment = process.env.NODE_ENV !== 'production';

const sanitize = (value) => {
  if (!value || typeof value !== 'object') return value;
  const copy = Array.isArray(value) ? [] : {};
  Object.keys(value).forEach((key) => {
    if (/password|token|secret|cookie/i.test(key)) {
      copy[key] = '[REDACTED]';
    } else {
      copy[key] = value[key];
    }
  });
  return copy;
};

const write = (level, message, context = {}) => {
  const entry = { level, message, ...sanitize(context) };
  const method = level === 'error' ? console.error : level === 'warn' ? console.warn : console.info;

  if (isDevelopment || level === 'error') {
    method(`[WeddingAdmin] ${message}`, entry);
  }
};

const logger = {
  info: (message, context) => write('info', message, context),
  warn: (message, context) => write('warn', message, context),
  error: (message, context) => write('error', message, context),
};

export default logger;
